import { useParams } from 'react-router-dom';

import { isMobile } from 'hooks';
import { Dialog } from 'components/dialog';
import { NewEntityButtonWithRef } from 'components/new-entity-button';
import { CreateAccountingExpenses } from 'components/accounting-expenses-form';

import { CommonFormProps } from './types';

export const CreateExpense = ({ eventId }: CommonFormProps) => {
  const mobile = isMobile();
  const { id } = useParams();
  return (
    <Dialog
      removeAutofocus
      title="Create Expense"
      width={mobile ? '90vw' : '720px'}
      trigger={<NewEntityButtonWithRef text="New Expense" />}
    >
      {(close) => (
        <CreateAccountingExpenses
          isDialog
          onClose={close}
          onSuccess={close}
          eventId={Number(id || eventId)}
        />
      )}
    </Dialog>
  );
};
